<template>
  <div>
    <p>
      Es gibt auch die Möglichkeit Geräte <strong>außerhalb</strong>
      des eigenen Netzwerks zu finden.
    </p>
    <p>
      Hierfür können Räume für verschiedene Themen oder Gruppen erstellt werden.
    </p>
    <p>
      Klicke hier auf den Raumnamen oder links auf das Menü
      <span class="d-inline-block">(<v-icon x-small>far fa-stream</v-icon>)</span>
      um zu den Räumen zu gelangen.
    </p>
  </div>
</template>

<script>
  import {switchRoom} from './step-utils';


  const component = {
    name: 'StepRooms'
  };


  export const StepRooms = {
    target: '.topbar .room-name',
    before: async () => {
      await switchRoom('local');
    },
    header: 'Räume',
    content: component
  };


  export default component;
</script>
